import _ from 'lodash';

import PropTypes from 'prop-types';

import useResponsive from '../../../utils/responsive';

const IconSection = (props) => {

    const { title, paragraph, icons } = props;
    
    const { isTablet, isSmallTablet } = useResponsive();

    const renderIcons = () => {
        return icons?.map((icon, index) => {
            const iconSrc = _.get(icon, 'icon_image.url');
            const iconTitle = _.get(icon, 'icon_title');
            const iconParagraph = _.get(icon, 'icon_paragraph');
            return (
                <div key={index} className='sales-icon-section-icon-and-text-container'>
                    <div className='sales-icon-section-icon-container'>
                        <img src={iconSrc} alt="" className='sales-icon-section-icon-image' />
                    </div>
                    <div>
                        <h5>{iconTitle}</h5>
                        <p className='sales-icon-section-dark-text-opacity'>{iconParagraph}</p>
                    </div>
                </div>
            );
        });
    };
    return (
        <div className='container-root container-root-maxWidthLg '>
            <div className='main-grid-container main-grid-spacing-xs-3 sales-icon-section-grid-container'>
                <div className={`main-grid-item ${isSmallTablet || isTablet ? 'main-grid-md-10' : 'main-grid-md-6'}`}>
                    <h2>{title}</h2>
                    <p className='sales-icon-section-paragraph'>{paragraph}</p>
                    {renderIcons()}
                </div>
            </div>
        </div>
    );
};

export default IconSection;

IconSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    icons: PropTypes.array,
};

